module.exports = __webpack_public_path__ + "img/CWoadRaider64_ua.b18b7da3.webp";